import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { DeliveryOption } from '../../../../models/delivery-options/delivery-option';
import { getMiddleMileIcon } from '../middle-mile-label.component';
import Button from '../../../../common/button/button.component';
import {
  DeliveryInfoTagsSection,
  DeliveryOptionCardRightContainer,
  MessageContainer,
  PriceSection,
  PriceSelectSection,
} from './styles';
import { getDeliveryTimeMessage } from '../helpers';
import { getPrice } from '../../../../routes/parcel-delivery/helpers';
import { testIds } from '../../../../../test-ids';
import { getFormattedPrice } from '../../../../utils/price/get-formatted-price';
import DeliveryInfoTag from '../delivery-info-tag.component';

interface Props {
  option: DeliveryOption;
  currencySymbol: string;
  isOptionSelected: boolean;
  onCardSelected: () => void;
}

const DeliveryOptionCardRight = ({
  option,
  currencySymbol,
  isOptionSelected,
  onCardSelected,
}: Props) => {
  const { t } = useTranslation();

  const optionPrice = getPrice(option);
  const deliveryTimeMessage = getDeliveryTimeMessage(option);
  const {
    middle_mile: { delivery_method: deliveryMethod },
    markers,
  } = option;

  return (
    <DeliveryOptionCardRightContainer>
      <DeliveryInfoTagsSection>
        {markers?.map((tag) => (
          <DeliveryInfoTag
            key={tag}
            type={tag}
          />
        ))}
        <MessageContainer>
          {getMiddleMileIcon(deliveryMethod)}
          {deliveryTimeMessage && deliveryTimeMessage}
        </MessageContainer>
      </DeliveryInfoTagsSection>
      <PriceSelectSection>
        <PriceSection
          data-testid={testIds.parceCreation.deliveryOptions.priceSection}>
          {getFormattedPrice(
            optionPrice,
            currencySymbol,
            deliveryMethod === 'expedited'
          )}
        </PriceSection>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onCardSelected();
          }}
          appearance={isOptionSelected ? 'primary' : 'secondary'}>
          {isOptionSelected
            ? t('delivery_options_card_selected')
            : t('delivery_options_card_select')}
        </Button>
      </PriceSelectSection>
    </DeliveryOptionCardRightContainer>
  );
};

export default observer(DeliveryOptionCardRight);
